import { SelectBox } from "components/Select/Select";
import {
  InputHTMLAttributes,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { trans } from "utils/helpers";
import { getApplications, setDefaultProcces } from "./api";

import { InputLoad } from "components/InputLoading/inputLoading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "components/Button/Button";
import {
  deleteProcessApplication,
  getProcessApplication,
  postProcessApplication,
} from "pages/OfficeAutomation/Settings/ProcessSetting/api/api";
import "./style.scss";
import { ICON_TYPE } from "utils/constants";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";
interface ApplicationProp extends InputHTMLAttributes<HTMLInputElement> {
  type: "SelectBox" | "Radio" | "CheckBox";
  label?: string;
  PRJ_UID?: string;
  name: string;
  value?: any;
  mode?: any;
  valueList?: any;
  required?: boolean;
  Change?: (e) => void;
  ApplicationListCallback?: (e) => void;
  returnObj?: any;
}
export const Application = ({
  type,
  returnObj = false,
  label,
  PRJ_UID,
  name,
  value,
  valueList,
  mode,
  required,
  Change,
  ApplicationListCallback,
}: ApplicationProp) => {
  const [optionsApplication, setOptionsApplication] = useState<any>();
  const [errcode, setErrcode] = useState<any>();
  const [app, setApp] = useState<any>();
  const [selectedItem, setSelectedItem] = useState<any>([]);
  const layoutContext = useContext(LayoutContext);
  let Default: any = value;
  let options_Application_values: any = [];
  let options_Application_keys: any = [];

  const ApplicationApiAsync = async () => {
    try {
      const res = await getApplications();

      setOptionsApplication(res.Data);
      if (PRJ_UID) {
        try {
          const response = await getProcessApplication(PRJ_UID);
          if (response.Data != null) {
            let Apps = Object.keys(response.Data).map((item, index) => {
              return { Id: item, Name: trans(response.Data[item].Name	), IsDefault: response.Data[item].IsDefault	 };
            });

            setSelectedItem(Apps);
          }else{
            setSelectedItem([]);
          }
        } catch (error) {
          setSelectedItem([]);
        }
      } else if (valueList && valueList.length > 0) {
        let Apps: any = [];

        res.Data.map((item) => {
          if (valueList.includes(item.Id)) {
            Apps.push({ Id: item.Id, Name: item.Name });
          }
        });
        setSelectedItem(Apps);
        //در مد ادیت  در صورتی که نخواهد روی دکمه ادآپشن بزند باید مقادیر از قبل انتخاب شده به صورت خودکار به کامپوننت والد هدایت شوند.

        ApplicationListCallback &&
          ApplicationListCallback(
            returnObj
              ? [
                  Apps.reduce((acc, curr) => {
                    acc[curr.Id] = curr.Name;
                    return acc;
                  }, {}),
                ]
              : Apps.map((item) => item.Id)
          );
        // عوض کردن فرمت دیتا به قالب زیر
        // [{Id: 'd602f192-5d5a-ec11-8946-00155d01ce1a', Name: 'OfficeAutomation'},                         {Id:'051b6708-eadb-ec11-8959-00155daa100d', Name: 'MeetingManagement'}]
        // ========>
        //  [{d602f192-5d5a-ec11-8946-00155d01ce1a: 'OfficeAutomation', 051b6708-eadb-ec11-8959-00155daa100d: 'MeetingManagement'}]
      } else {
        setSelectedItem([]);
      }
    } catch (error: any) {
      setErrcode(error.response?.status);
    }
  };

  function addOption(e) {
    e.stopPropagation();
    e.preventDefault();
    let Name;

    if (app || options_Application_keys[0]) {
      let Id = app?.target?.value
        ? app?.target?.value
        : options_Application_keys[0];
      let query = {
        applicationId: Id,
        PRJ_UID: PRJ_UID,
      };

      optionsApplication.forEach((item) => {
        if (item.Id == Id) {
          Name = item.Name;
        }
      });

      let obj = {};
      if (ApplicationListCallback) {
        let selectList = JSON.parse(JSON.stringify(selectedItem));
        let list: any = [];
        let listId = selectList.map((item) => {
          list.push(item.Id);
          return returnObj ? (obj = { ...obj, [item.Id]: item.Name }) : item.Id;
        });

        if (!list.includes(Id)) {
          ApplicationListCallback(
            returnObj ? [{ ...obj, [Id]: Name }] : [...listId, Id]
          );
          setSelectedItem([...selectList, { Id: Id, Name: Name }]);
        }
      } else {
        sendDataasync(query, { Id: Id, Name: Name });
      }
    }
  }

  const sendDataasync = async (e, obj) => {
    try {
      const respons = await postProcessApplication(e);
      let selectList = JSON.parse(JSON.stringify(selectedItem));
      setSelectedItem(selectList.concat([obj]));
    } catch (error) {}
  };
  const setDefaultAsync = async (Id) => {
    try {
      const respons = await setDefaultProcces(Id , PRJ_UID);
      if (PRJ_UID) {
        try {
          const response = await getProcessApplication(PRJ_UID);
          if (response.Data != null) {
            let Apps = Object.keys(response.Data).map((item, index) => {
              return { Id: item, Name: trans(response.Data[item].Name	), IsDefault: response.Data[item].IsDefault	 };
            });

            setSelectedItem(Apps);
          }
        } catch (error) {
          setSelectedItem([]);
        }
      } 
    } catch (error) {}
  };

  async function deleteaOption(obj) {
    if (ApplicationListCallback) {
      let selectList: any = [];
      selectedItem.map((e) => {
        if (e.Id != obj.Id) {
          selectList.push(e);
        }
      });
      setSelectedItem(selectList);
            // عوض کردن فرمت دیتا به قالب زیر
        // [{Id: 'd602f192-5d5a-ec11-8946-00155d01ce1a', Name: 'OfficeAutomation'},                         {Id:'051b6708-eadb-ec11-8959-00155daa100d', Name: 'MeetingManagement'}]
        // ========>
        //  [{d602f192-5d5a-ec11-8946-00155d01ce1a: 'OfficeAutomation', 051b6708-eadb-ec11-8959-00155daa100d: 'MeetingManagement'}]
      ApplicationListCallback(
        returnObj
          ? [selectList.reduce((acc, curr) => {
            acc[curr.Id] = curr.Name;
            return acc;
          }, {})]
          : selectList.map((item) => item.Id)
      );
    } else {
      let query = {
        applicationId: obj.Id,
        PRJ_UID: PRJ_UID,
      };

      try {
        const response = await deleteProcessApplication(query);
        ApplicationApiAsync();
      } catch (error) {}
    }
  }

  useEffect(() => {
    ApplicationApiAsync();
  }, [
    layoutContext.currentUserPosition.PositionId,
    layoutContext.currentApplication,
    valueList?.length,
  ]);

  if (optionsApplication)
    options_Application_values = optionsApplication.map((item) => {
      return item.Name;
    });
  if (optionsApplication)
    options_Application_keys = optionsApplication.map((item) => {
      return item.Id;
    });
  if (
    value &&
    optionsApplication &&
    options_Application_keys.indexOf(value) != -1
  ) {
    Default = value;
  } else if (
    optionsApplication &&
    options_Application_values.indexOf(value) != -1
  ) {
    Default = options_Application_values.indexOf(value) + 1;
  }

  return (
    <>
      {label ? (
        <label className="Application__label">{trans(label)}</label>
      ) : null}
      {true ? (
        <>
          <form
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              width: "100%",
            }}
          >
            <div style={{ width: "90%" }}>
              <SelectBox
                onChange={(e) => {
                  setApp(e);
                  e.target.value !=
                  (value ? value : options_Application_keys[0])
                    ? Change && Change({ [name]: e.target.value })
                    : Change && Change({ [name]: null });
                }}
                required={required}
                mode={mode}
                lable="Application"
                selectType="select"
                value={Default}
                options={options_Application_values}
                val={options_Application_keys}
                name={name}
              ></SelectBox>
            </div>
            {mode != "view" && (
              <div style={{ marginTop: "22px", width: "10%" }}>
                <Button
                  Icon={true}
                  value={
                    <button onClick={addOption} className="checkButton">
                      {" "}
                      <FontAwesomeIcon icon={[ICON_TYPE, "check"]} size="2x" />
                    </button>
                  }
                  btnType="submit"
                />
              </div>
            )}
          </form>
          <div className="group-person__selected-options-wrapper">
            {selectedItem.map((item, index) => (
              <div
                className="group-person__selected-option form-control-custom"
                key={item.Id + index}
              >
                <div
                  className="group-person__defult-selected-option"
                  data-key={item.Id}
                >
                  {!ApplicationListCallback ? (
                    item.IsDefault ? (
                      <FontAwesomeIcon
                        icon={[ICON_TYPE, "star"]}
                        className="text-primary"
                      />
                    ) : (
                      <FontAwesomeIcon
                        onClick={(e)=>{setDefaultAsync(item.Id)}}
                        icon={["far", "star"]}
                        className="text-primary"
                      />
                    )
                  ) : (
                    <></>
                  )}
                </div>
                <div
                  style={{
                    marginRight: ApplicationListCallback ? "0" : "13px",
                  }}
                >
                  {trans(item.Name)}
                </div>

                <div
                  className="group-person__delete-selected-option"
                  data-key={item.Id}
                  onClick={() => {
                    deleteaOption(item);
                  }}
                >
                  <FontAwesomeIcon icon={[ICON_TYPE, "times"]} />
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <InputLoad
          msg={errcode}
          required={required}
          labelText={label}
          onClick={ApplicationApiAsync}
        />
      )}
      <div className="text-box__msg-wrapper"></div>
    </>
  );
};
